import { PAUSE_SONG, PLAY_SONG, TOGGLE_PLAYING, SHUFFLE, SET_REPEAT, MUTE } from './actions';

const initialState = {
  /**
   * Wheather the song is playing or not
   */
  playing: false,

  /**
   * Wheather to repeat the current playlist or not
   */
  repeat: 'none', // none, all, one

  /**
   * The current song playing
   */
  song: undefined,

  /**
   * Whether the user shaffled the queue or not
   */
  shuffled: false,

  /**
   * Whether the player is muted or not
   */
  muted: false,

  /**
   * The list of songs in queue
   */
  queue: [],

  /**
   * The original queue order, in case the user wants to go back after shuffle
   */
  original: []
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case PAUSE_SONG:
      return {
        ...state,
        playing: false,
      };
    case PLAY_SONG:
      return {
        ...state,
        playing: true,
        song: action.payload.song,
        queue: action.payload.queue,
        original: action.payload.queue,
      };
    case TOGGLE_PLAYING:
      return {
        ...state,
        playing: !state.playing,
      };
    case SHUFFLE:
      return {
        ...state,
        shuffled: !state.shuffled,
        queue: state.shuffled ? state.original : action.payload.queue,
      };
    case SET_REPEAT:
      return {
        ...state,
        repeat: action.payload.repeat,
      };
    case MUTE:
      return {
        ...state,
        muted: !state.muted,
      };
    default:
      return state;
  }
}
